'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _configs = require('./configs');

var _configs2 = _interopRequireDefault(_configs);

var _extractUrlsWithIndices = require('./extractUrlsWithIndices');

var _extractUrlsWithIndices2 = _interopRequireDefault(_extractUrlsWithIndices);

var _getCharacterWeight = require('./lib/getCharacterWeight');

var _getCharacterWeight2 = _interopRequireDefault(_getCharacterWeight);

var _modifyIndicesFromUTF16ToUnicode = require('./modifyIndicesFromUTF16ToUnicode');

var _modifyIndicesFromUTF16ToUnicode2 = _interopRequireDefault(_modifyIndicesFromUTF16ToUnicode);

var _nonBmpCodePairs = require('./regexp/nonBmpCodePairs');

var _nonBmpCodePairs2 = _interopRequireDefault(_nonBmpCodePairs);

var _parseTweet = require('./parseTweet');

var _parseTweet2 = _interopRequireDefault(_parseTweet);

var _urlHasHttps = require('./regexp/urlHasHttps');

var _urlHasHttps2 = _interopRequireDefault(_urlHasHttps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getTweetLength = function getTweetLength(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _configs2.default.defaults;

  return (0, _parseTweet2.default)(text, options).weightedLength;
}; // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = getTweetLength;
module.exports = exports['default'];